module.exports = __webpack_public_path__ + "media/career/04-benefit-house-pricing-572b6891.svg";